<template>
<div v-cloak>
    <div class="header pc">
        <div class="header-core core">
            <img src="/static/logo.png" alt="" class="header-logo">
            <div class="header-menu">
                <div class="header-menu-item">
                  <router-link to="/">首页</router-link>
                </div>
                <div class="header-menu-item" v-for="(menuItem, menuIndex) in menu" :key="menuIndex">
                  <div class="header-menu-item-top" v-if="'children' in menuItem">
                    {{ menuItem.name }}<!-- &nbsp;<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <div class="menu-dropdown">
                      <router-link :to="menuSubItem.url" v-for="(menuSubItem, subIndex) in menuItem['children']" :key="subIndex" class="menu-sub-item">
                        {{ menuSubItem.name }}
                        <div class="menu-dropdown-sub" v-if="'children' in menuSubItem">
                          <router-link :to="nextSubItem.url" v-for="(nextSubItem, nextIndex) in menuSubItem['children']" :key="nextIndex" class="menu-sub-item-sub">
                            {{ nextSubItem.name }}
                          </router-link>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <router-link :to="menuItem.url" v-else>{{ menuItem.name }}</router-link>
                </div>
            </div>
            <div class="header-search">
              <input type="text" v-model="searchValue" class="header-search-input" placeholder="请输入产品" @keyup.enter="search()">
              <div class="header-search-btn" @click="search()">
                <i class="el-icon-search"></i>
              </div>
            </div>
        </div>
    </div>
    <div class="banner block pc">
      <el-carousel height="536px">
        <el-carousel-item class="banner-item" v-for="(banner,bannerIndex) in bannerList" :key="bannerIndex">
          <img :src="'http://image.teamcorp.cn/wo_de/banner/' + banner.image" :alt="banner.title" @click="$router.push(banner.url)">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="core">
        <router-view>暂无内容</router-view>
    </div>
    <div class="footer pc">
      <div class="core">
        <div class="footer-info">
          <a href="http://beian.miit.gov.cn" style="text-decoration:none;color: #ffffff;">京ICP备19048474号</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>沃德精准（北京）科贸有限公司</span><br>
          <span>地址：北京市海淀区农大南路1号硅谷亮城5号楼609室</span><br>
          <span>电话：010-80748842</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>传真：010-80748842</span><br>
          <span>投诉电话：13810842696</span><br>
          <span>公司邮箱：sales@wd-jingzhun.com.cn</span>
        </div>
        <div class="footer-coder">
          <div>关注公共号</div>
          <img src="/static/coder.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="floater pc" v-show="floaterShow">
      <div class="floater-item" @click="qqAsk">
        <img src="/static/qq.jpg" alt="">
        <div>QQ咨询</div>
      </div>
      <div class="floater-item" @click="phoneAsk">
        <img src="/static/phone.jpg" alt="">
        <div>电话咨询</div>
      </div>
      <div class="floater-item" @click="toTop">
        <img src="/static/top.jpg" alt="">
        <div>返回顶部</div>
      </div>
    </div>
</div>
</template>

<script>
import service from '@/utils/service'
import { Notification } from 'element-ui'

export default {
  data () {
    return {
      hasBanner: true,
      searchValue: '',
      menu: [],
      bannerList: [],
      floaterShow: false
    }
  },
  created () {
    this.loadBanners()
    this.loadMenus()
    if ('search' in this.$route.query) {
      this.searchValue = this.$route.query.search
    }
  },
  mounted () {
    window.addEventListener('scroll', this.floaterCheck)
  },
  methods: {
    bindMenuSlide () {
      let menu = document.getElementsByClassName('header-menu-item-top')
      for (var i = 0; i < menu.length; i++) {
        menu[i].onmouseenter = function () {
          this.getElementsByClassName('menu-dropdown')[0].style.display = 'block'
          // // this.style.background = '#018FD7'
          // this.style.opacity = 0.95
          // this.style.color = '#018FD7'
        }
        menu[i].onmouseleave = function () {
          this.getElementsByClassName('menu-dropdown')[0].style.display = 'none'
          // this.style.background = 'none'
          // this.style.color = '#ffffff'
          // this.style.color = '#333333'
        }
      }
      let sub = document.getElementsByClassName('menu-sub-item')
      for (var i = 0; i < sub.length; i++) {
        sub[i].onmouseenter = function () {
          if(this.getElementsByClassName('menu-dropdown-sub').length>0) {
            this.getElementsByClassName('menu-dropdown-sub')[0].style.display = 'block'
            // this.style.background = '#018FD7'
            // this.style.opacity = 0.95
            // this.style.color = '#ffffff'
          }
        }
        sub[i].onmouseleave = function () {
         if(this.getElementsByClassName('menu-dropdown-sub').length>0) {
           this.getElementsByClassName('menu-dropdown-sub')[0].style.display = 'none'
           // this.style.background = 'none'
           // this.style.color = '#ffffff'
           // this.style.color = '#333333'
         }
        }
      }
    },
    loadBanners () {
      let _this = this
      service.get('/banner/banners').then(function (response) {
        _this.bannerList = response
      })
    },
    loadMenus () {
      let _this = this
      service.get('/user/topMenus').then(function (response) {
        _this.menu = response
        setTimeout(function () {
          _this.bindMenuSlide()
        }, 800)
      })
    },
    search () {
      let search = this.searchValue.replace(' ', '')
      if (search.length === 0) {
        alert('搜索产品不能为空')
      }
      this.$router.push({'path': '/product/search', 'query': {search: search}})
      if (this.$route.path === '/product/search') {
        this.$route.query.search = search
      }
    },
    toTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    qqAsk () {
      // window.open('mqqapi://card/show_pslcard?src_type=internal&version=1&uin=2434375524&card_type=group&source=qrcode', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no')
      window.open('tencent://message/?Menu=yes&uin=2434375524&Site=80fans&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a545b1714f9d45','_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no')
    },
    phoneAsk () {
      Notification.success({
        title: '公司电话',
        message: '请拨打电话：010-80748842',
        showClose: true
      })
    },
    floaterCheck () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if ((scrollTop + windowHeight) < 800 || (scrollHeight - scrollTop - windowHeight) < 175) {
        this.floaterShow = false
      } else {
        this.floaterShow = true
      }
    }
  }
}
</script>

<style scoped>
.header {
  background: none;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
.header-core {
  display: flex;
  align-items: stretch;
  height: 64px;
  padding:0;
}
.header-logo {
  width: 152px;
  height: 38px;
  margin: 9px 7px 17px 0;
}
.header-menu {
  flex: 1;
  display: flex;
  height:64px;
  align-items: flex-start;
}
.header-search {
  width: 224px;
  height:30px;
  display:flex;
  background: #ffffff;
  margin: 17px 0 17px 0;
}
.header-search-input {
  font-size:14px;
  padding: 5px 8px;
  flex:1;
  border:none;
  outline: none;
  color:#515151;
}
.header-search-btn {
  width:30px;
  text-align: center;
  background: #ffffff;
  cursor: pointer;
  color:#515151;
}
.menu-dropdown{
  position: absolute;
  left:0;
  top:100%;
  /*background: #018FD7;*/
  background: #ffffff;
  text-align: center;
  display: none;
  width: 100%;
  padding: 10px 0 0 0;
  opacity:0.95;
  color:#ffffff;
  border-radius: 5px;
  /* border-left:solid 1px #aaaaaa; */
}
.menu-dropdown-sub{
  position: absolute;
  left:100%;
  /*background: #018FD7;*/
  background: #ffffff;
  text-align: center;
  display: none;
  width: 100%;
  padding: -30px 0 0 0;
  opacity:0.95;
  color:#ffffff;
  border-radius: 5px;
  margin-top: -30%;
  /*border:solid 1px red;*/
}
.menu-sub-item {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", "Microsoft YaHei", "Source Han Sans SC", "Noto Sans CJK SC", "WenQuanYi Micro Hei", sans-serif;
  /*color:#ffffff;*/
  color: #282828;
  font-size: 14px;
  line-height: 100%;
  cursor: pointer;
  width: 100%;
  display: block;
  padding: 10px 0;
  border-bottom:solid 2px #f1f1f1;
}

.menu-sub-item-sub {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", "Microsoft YaHei", "Source Han Sans SC", "Noto Sans CJK SC", "WenQuanYi Micro Hei", sans-serif;
  /*color:#ffffff;*/
  color: #282828;
  font-size: 14px;
  line-height: 100%;
  cursor: pointer;
  width: 100%;
  display: block;
  padding: 10px 0;
  border-bottom:solid 2px #f1f1f1;
}
.menu-sub-item-sub:hover{
  /*background: #018FD7;*/
  color: #018FD7;
}
.menu-sub-item:hover{
  /*background: #018FD7;*/
  color: #018FD7;
}

.header-menu-item{
  width:115px;
  text-align: center;
  margin:0;
  font-family: "微软雅黑 sans-serif";
  /*color: #333333;*/
  color: white;
  font-size: 15px;
  line-height: 100%;
  cursor: pointer;
}
.header-menu-item:after {
  width:1px;
  border-right: solid 1px #333333;
}
.header-menu-item >a {
  font-family: "微软雅黑 sans-serif";
  /*color: #333333;*/
  color: white;
  font-size: 15px;
  line-height: 100%;
  cursor: pointer;
  padding: 24px 0 10px 0;
  display: inline-block;
}
.active {
  background: #DCE6EF;
}
.header-menu-item-top {
  font-family: "微软雅黑 sans-serif";
  /*color: #333333;*/
  color: white;
  font-size: 15px;
  line-height: 100%;
  position: relative;
  cursor: pointer;
  width: 100%;
  padding: 24px 0 10px 0;
}
.header-menu-item:last-child {
  border: none;
}

.header-mobile{
  width: 100%;
}
.header-mobile-title {
  margin-top:42px;
  height:72px;
  display:flex;
}
.header-mobile-logo {
  width:283px;
  height:75px;
  margin: 0;
}
.banner {
  width: 100%;
  height: 536px;
  overflow: hidden;
  display: block;
}
.banner-item {
  height: 536px;
  cursor: pointer;
  display:flex;
  justify-content: center;
  align-items: center;
}
.banner-item img {
  display: block;
}

@media screen and (min-width:321px) and (max-width:1200px){

}
.footer {
  background: #515151;
  width: 100%;
  margin-top: 55px;
  padding:32px;
}
.footer .core {
  display: flex;
}
.footer span,
div {
  color: #ffffff;
  font-size: 12px;
  line-height: 220%;
}
.footer-info {
  flex: 1;
}
.footer-coder {
  width: 98px;
}
.footer-coder div {
  color:#a3a3a3;
  width: 100%;
  text-align: center;
}
.floater {
  position: fixed;
  /* right:41px; */
  right:1%;
  bottom:20px;
  border: solid 1px #f0f0f0;
  width:61px;
  background: #ffffff;
  z-index:100000;
}
.floater-item {
  width:61px;
  height:61px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: solid 1px #f0f0f0;
  cursor:pointer;
}
.floater-item div {
  font-size:12px;
  color:#515151;
  line-height: 150%;
}
.floater-item:last-child {
  border-bottom: none;
}
.ask{
   border: 1px solid red;
   width:120px;
   display: flex;
   flex-direction: column-reverse;
   position: absolute;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/Main.vue